import React from 'react';
import { Box, Typography, Container, Link, Grid, IconButton, useTheme } from '@mui/material';
import { Facebook, Twitter, Email, Phone } from '@mui/icons-material';

const Footer = () => {
  const theme = useTheme();
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        px: 2,
        mt: 'auto',
        backgroundColor: theme.palette.mode === 'light'
          ? 'rgba(232, 236, 241, 0.8)'
          : 'rgba(0, 0, 0, 0.1)',
        borderTop: `1px solid ${theme.palette.divider}`
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={8} md={6}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Zaror Sports
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Your premier destination for custom sports kit design and personalized team apparel.
            </Typography>

            <Box id="footer-contact" sx={{ mb: 3, scrollMarginTop: { xs: 80, md: 96 } }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontWeight: 500 }}>
                For any inquiries please email or call us:
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Email sx={{ fontSize: 18, color: 'primary.main', mr: 1 }} />
                <Link
                  href="mailto:info@zaror.co.uk"
                  color="text.secondary"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': {
                      color: 'primary.main',
                    }
                  }}
                >
                  info@zaror.co.uk
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Phone sx={{ fontSize: 18, color: 'primary.main', mr: 1 }} />
                <Link
                  href="tel:01216901020"
                  color="text.secondary"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': {
                      color: 'primary.main',
                    }
                  }}
                >
                  0121 690 1020
                </Link>
              </Box>
            </Box>

            <Box sx={{ mt: 2 }}>
              <IconButton
                color="primary"
                aria-label="facebook"
                component="a"
                href="https://www.facebook.com/zarorsports"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook />
              </IconButton>
              <IconButton
                color="primary"
                aria-label="twitter"
                component="a"
                href="https://x.com/zarorsports"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 5, pt: 3, borderTop: `1px solid ${theme.palette.divider}`, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © {year} Zaror Sports. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
